import { PlantImages } from "@/types";

import { images as images0 } from "./images-0";
import { images as images1 } from "./images-1";
import { images as images2 } from "./images-2";

export const images: PlantImages = { ...images0, ...images1, ...images2 };
